<template>
  <div class="course">
    <div v-if="showDefault" class="default-page">
      <img :src="defaultImg" />
      <p>请先选择学校、学期、课程类别和上课日期</p>
    </div>
    <div v-else class="table-wrap">
      <Table
        :columns="columns"
        :loading="loading"
        :data="courseList"
        border
        max-height="500"
      >
        <template slot="course" slot-scope="{ row, index }">
          <div class="course-list">
            <div
              v-for="(x, y) in row.list"
              :key="y"
              class="table-btn"
              :class="x.select ? 'table-btn-fill' : 'table-btn-nofill'"
              @click="handleToggleSelect(x, row, index)"
            >
              {{ x.classroomName }}
            </div>
          </div>
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <div
            class="table-btn table-btn-big action-btn table-btn-fill"
            @click="handleSelectAll(row, index)"
          >
            全选
          </div>
          <div
            class="table-btn table-btn-big action-btn table-btn-nofill"
            @click="handleCancelAll(row, index)"
          >
            取消
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showDefault: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    } // v-model的值
  },
  data() {
    return {
      defaultImg: require('@/assets/img/empty2@2x.png'),
      columns: [{
        title: '日期',
        key: 'classDateShow',
        width: 150,
        align: 'center'
      }, {
        title: '课班名称',
        slot: 'course',
        align: 'center'
      }, {
        title: '操作',
        slot: 'action',
        width: 200,
        align: 'center'
      }],
      selectList: [] // 选择的课程
    };
  },
  computed: {
    courseList: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    } // 课程信息
  },
  methods: {
    // 切换是否选中课程
    handleToggleSelect(x, row, index) {
      x.select = !x.select;
      this.courseList.splice(index, 1, row);
    },
    // 全选该行课程
    handleSelectAll(row, index) {
      row.list.forEach(item => {
        item.select = true;
      });
      this.courseList.splice(index, 1, row);
    },
    // 全不选该行
    handleCancelAll(row, index) {
      row.list.forEach(item => {
        item.select = false;
      });
      this.courseList.splice(index, 1, row);
    }
  }
};
</script>

<style lang="scss" scoped>
.course {
  margin-bottom: 42px;
}
.default-page {
  text-align: center;
  padding-top: 64px;
  img {
    width: 200px;
    margin-bottom: 16px;
  }
}
.table-btn {
  display: inline-block;
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  padding: 0 16px;
  color: #fff;
  border-radius: 9px;
  margin: 8px 8px 8px 0;
  cursor: pointer;
}
.table-btn-big {
  font-size: 14px;
  height: 24px;
  line-height: 24px;
  border-radius: 12px;
}
.table-btn-fill {
  background: rgba(0, 100, 244, 0.8);
}
.table-btn-nofill {
  background: #ccc;
}
.course-list {
  width: 100%;
  text-align: left;
}
.action-btn {
  opacity: 0.85;
}
</style>
